import React, { useEffect } from "react";
import { applyTheme, THEMES } from "./components/ThemeToggle";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./themes/theme-variables.scss";
import SiteNavbar from "./SiteNavbar";
import AppMain from "./pages/AppMain";
import UserProfile from "./pages/user/UserProfile";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Logout from "./pages/Logout";
import TradingStrategies from "./pages/strategies/TradingStrategies";
import BacktestPage from "./pages/backtest/BacktestPage";

function App() {
  const location = useLocation();
  const isHomePage    = location.pathname === "/";
  const noContainer   = isHomePage || location.pathname === "/backtest";

  useEffect(() => {
    const saved = localStorage.getItem('rv-theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (saved && THEMES.find((t) => t.id === saved)) {
      applyTheme(saved);
    } else {
      applyTheme(prefersDark ? 'midnight' : 'slate');
    }
  }, []);

  return (
    <div className="App">
      <SiteNavbar />
      <div className={noContainer ? "" : "container-fluid"}>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/login/" element={<Login />}></Route>
          <Route path="/signup" element={<Signup />}></Route>
          <Route path="/signup/" element={<Signup />}></Route>
          <Route path="/logout" element={<Logout />}></Route>
          <Route path="/logout/" element={<Logout />}></Route>
          <Route path="/app/" element={<AppMain />}></Route>
          <Route path="/user/profile" element={<UserProfile />}></Route>
          <Route path="/strategies/TradingStrategies" element={<TradingStrategies />}></Route>
          <Route path="/backtest" element={<BacktestPage />}></Route>
        </Routes>
      </div>
    </div>
  );
}

export default App;
